<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="pr-1"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="pl-1"><a routerLink="/list-ta-admin-requests">Tenant Admin
                Requests</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="pl-1">Work Entry Permit Details</span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="pl-1">SME Groups</span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1">SME Group Details</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">SME Group 1</h2>
    </div>
    <div
        class="search_bar border-top border-bottom border-light mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mb-4 mb-md-5">
        <form class="search_form">
            <svg-icon src="../../../assets/images/icons/search.svg"></svg-icon>
            <input type="text" name="searchText" id="searchText" class="search_field" placeholder="Search by Name...">
            <button type="submit" class="d-none"></button>
        </form>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{smes.length}} SME{{smes.length > 1 ? 's' : null}}</h3>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4" *ngFor="let sme of smes; let i=index ">
            <div class="bg-lighter p-3 rounded">
                <div class="d-flex align-items-center column-gap-2 profile_card column-gap-3 mb-2 mb-md-3">
                    <span class="_img">
                        <img [src]="sme.userImage? sme.userImage : '../../../assets/images/avatar.jpg'" alt="">
                        <svg-icon src="../../../assets/images/icons/user_guard.svg" class="user_guard"
                            *ngIf="sme.userGuard"></svg-icon>
                    </span>
                    <div class="d-flex flex-column">
                        <h3 class="font-weight-bold text-primary h5 mb-1">{{sme.name}}</h3>
                        <span class="small text-muted">Username: {{sme.userName}}</span>
                        <span class="small text-muted">SME Group: {{sme.groupName}}</span>
                    </div>
                </div>
                <span class="font-weight-bold small text-primary cursor-pointer">Assign</span>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4">
        <div class="row d-flex pagination-border">
            <pagination-controls class="pagination" previousLabel="" nextLabel="" class="d-flex justify-content-center">
            </pagination-controls>
            <div class="pr-3 ratio-class pt-1">1/1</div>
        </div>
    </div>
</div>